module.exports = __webpack_public_path__ + "static/img/262_TO8_2341_og.02d69b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/262_TO8_2341_og.jpg
// module id = Cdxe
// module chunks = 0